import { memo } from 'react';
import { motion } from 'framer-motion';

import { useGetParams } from '../../hooks/useGetParams';

import { BgVideo } from '../BgVideo/BgVideo';

import styles from './Advt.module.css';

import logo from '../../assets/images/logo.png';

export const Advt = memo(() => {
  const { title, qrCode1, qrCode2, titleFontSize, sizeQR } = useGetParams();

  const wordsTitle = title?.split(' ');

  return (
    <div className={styles.advtBlock}>
      <div className={styles.logoAndTitle}>
        <img src={logo} alt="" className={styles.logo} />

        {wordsTitle && (
          <div
            className={styles.title}
            style={{ fontSize: `${titleFontSize}rem` }}
          >
            <motion.div
              initial={{ maskPosition: '100% 100%' }}
              animate={{ maskPosition: '0% 100%' }}
              transition={{ duration: 0.5 }}
              className={styles.titleBg}
            />

            {wordsTitle.map((w, idx) => (
              <motion.div
                key={w + idx}
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: [0, 1.35, 1], opacity: 1 }}
                transition={{
                  opacity: { duration: 1, delay: 0.2 + idx * 0.5 },
                  scale: {
                    duration: 1,
                    delay: idx * 0.5,
                    times: [0, 0.7, 1],
                    ease: ['easeIn', 'easeOut'],
                  },
                }}
              >
                {w}
              </motion.div>
            ))}
          </div>
        )}
      </div>

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6 }}
            className={styles.qrCode}
          >
            <img
              src={qrCode1}
              alt="QR"
              style={{
                height: `${sizeQR}rem`,
                width: `${sizeQR}rem`,
              }}
            />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className={styles.qrCode}
          >
            <img
              src={qrCode2}
              alt="QR"
              style={{
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            />
          </motion.div>
        )}
      </div>

      <BgVideo />
    </div>
  );
});
